import React from 'react';

import { IFormFieldInputBaseProps } from '@components/form-fields';
import { MAIN_THEME } from '@styles';

import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

interface ILoader extends IFormFieldInputBaseProps {
  width?: number | string;
  height?: number | string;
  text?: string;
  position?: 'parentCenter' | 'fullCenter';
}

const useStyles = makeStyles()(() => ({
  circle: {
    fill: MAIN_THEME.color.black
  },
  loaderText: {
    fontSize: MAIN_THEME.fontSize.lg,
    textAlign: 'center',
    letterSpacing: '0.24px',
    lineHeight: '32px',
    color: MAIN_THEME.color.black25,
    marginTop: '-10px',
    fontFamily: MAIN_THEME.font.regular
  },
  loaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignContent: 'center'
  },
  fullCenter: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  parentCenter: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const Loader: React.FC<ILoader> = ({
  width = 100,
  height = 100,
  position,
  text,
  className,
  style
}) => {
  const { classes } = useStyles();

  return (
    <div
      className={clsx(classes.loaderContainer, {
        [classes.fullCenter]: position === 'fullCenter',
        [classes.parentCenter]: position === 'parentCenter'
      })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width={width}
        height={height}
        className={className}
        style={style}
      >
        <circle
          className={classes.circle}
          transform="translate(8 0)"
          cx="0"
          cy="16"
          r="0"
        >
          <animate
            attributeName="r"
            values="0; 4; 0; 0"
            dur="1.2s"
            repeatCount="indefinite"
            begin="0"
            keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8"
            calcMode="spline"
          />
        </circle>
        <circle
          className={classes.circle}
          transform="translate(16 0)"
          cx="0"
          cy="16"
          r="0.0854297"
        >
          <animate
            attributeName="r"
            values="0; 4; 0; 0"
            dur="1.2s"
            repeatCount="indefinite"
            begin=".3"
            keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8"
            calcMode="spline"
          />
        </circle>
        <circle
          className={classes.circle}
          transform="translate(24 0)"
          cx="0"
          cy="16"
          r="2.23425"
        >
          <animate
            attributeName="r"
            values="0; 4; 0; 0"
            dur="1.2s"
            repeatCount="indefinite"
            begin=".6"
            keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8"
            calcMode="spline"
          />
        </circle>
      </svg>
      {text && <p className={classes.loaderText}>{text}</p>}
    </div>
  );
};

export default Loader;
